<template>
    <div class="xhdetail24">
        <div class="header">
            <img :src="detail.imgurl" alt="">
        </div>
        <div class="body">
            <div class="tabs">
                <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="item in tablist" :key="item.id">{{item.name}}</div>
            </div>
            <div class="centent">
                <div class="html">
                    <!-- <template v-if="active==1">
                        <div class="draw" v-if="acid" @click="godraw"></div>
                        <div class="sublist">
                            <div class="citem" @click="godetail(item)" v-for="item in sublist">
                                <div class="tt">
                                    <div>{{item.title}}</div>
                                    <div><van-icon name="clock-o" />{{item.start_time_show}} ~ {{item.end_time_show}}</div>
                                </div>
                                <div class="img"></div>
                            </div>
                        </div>
                    </template> -->
                        
                    <div v-html="active==1?detail.disclaimer:detail.intro"></div>
                </div>
            </div>
            <div class="foot">
                <img @click="godetail()" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20241006/1728186965/1728186976657/WechatIMG53.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import "./index.less";
export default {
    props: ["activity_id","acid"],
    data() {
        return {
            detail: {},
            tablist: [
                {
                    id: 1,
                    name: '活动规则'
                },{
                    id: 2,
                    name: '奖励办法'
                }
            ],
            sublist: [],
            active: 1
        };
    },
    methods: {
        godraw() {
            this.$router.push({name:'luckdraw',params:{'acid':this.acid}})
        },
        godetail() {
            let val = this.detail
            if(val.jump_url) {
                if(val.jump_url.indexOf('https') != -1) {
                    window.location.href = val.jump_url
                    return
                }
                wx.miniProgram.navigateTo({
                    url:val.jump_url
                });
                return
            }
        },
        init: function () {
            this.$toast.loading({
                duration: 0,
            });
            let params = { activity_id: this.activity_id };
            this.$api.activity.taskList(params).then(res => {
                if(res.status==200){
                    this.detail = res.data
                }
            });
        },
    },
    mounted() {
        this.init();
    },
}
</script>